var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup34405(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    fill: "#262626",
    stroke: "#2D2D2D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9943 16.6317V16.9994C25.9938 17.8614 25.7147 18.7001 25.1986 19.3904C24.6825 20.0808 23.957 20.5858 23.1305 20.8302C22.3039 21.0746 21.4205 21.0453 20.6119 20.7466C19.8034 20.4479 19.1131 19.8958 18.6439 19.1727C18.1748 18.4496 17.952 17.5942 18.0087 16.7341C18.0654 15.8741 18.3986 15.0553 18.9586 14.4001C19.5187 13.7449 20.2755 13.2882 21.1162 13.0983C21.957 12.9083 22.8366 12.9952 23.624 13.346",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9931 13.8018L21.996 17.8029L20.7969 16.6037",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3866 15H12V26.0924H28.6387V17.6891",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 26L15.3613 29.6218H32L28.6387 26.0924",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup34405);
export default __webpack_public_path__ + "static/media/Group 34405.1e3acf4f52f31358a86c292cf83ed078.svg";
export { ForwardRef as ReactComponent };